import { useState, useEffect, useRef } from "react";

const SC_NAV = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABMAgMAAACHa9jeAAABAGlDQ1BpY2MAABiVY2BgPMEABCwGDAy5eSVFQe5OChGRUQrsDxgYgRAMEpOLCxhwA6Cqb9cgai/r4lGHC3CmpBYnA+kPQKxSBLQcaKQIkC2SDmFrgNhJELYNiF1eUlACZAeA2EUhQc5AdgqQrZGOxE5CYicXFIHU9wDZNrk5pckIdzPwpOaFBgNpDiCWYShmCGJwZ3AC+R+iJH8RA4PFVwYG5gkIsaSZDAzbWxkYJG4hxFQWMDDwtzAwbDuPEEOESUFiUSJYiAWImdLSGBg+LWdg4I1kYBC+wMDAFQ0LCBxuUwC7zZ0hHwjTGXIYUoEingx5DMkMekCWEYMBgyGDGQCm1j8/yRb+6wAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEXJqEzJqEz////KyOVbAAAAAXRSTlMAQObYZgAAAAFiS0dEAmYLfGQAAAAHdElNRQfqAxgKNx+5nr/zAAAB5UlEQVQ4y41UMY7tMAiEgn4Lcx+7cI8luP9VPmCyP3FSbKSnxGN7YGB4ANdjBq8HzfoLJDP5G8hm+gaVP0Chv5785PwCzT4kfYGoZnzqRGGlE6QAT508zMYZniPQCZp9hPdjfIK4wX6AKsQHSDY6jqP2bNRRjvDMBCD6BI0bQNNneNUAmZ81Uo9B/KgTygpwPurkNepxHu850cwQtu7hmTf4yKmq9izJtbiD6KLRlnkJ+g3sYUXLj7wRCdrux+8qPsNvuxssSdy8se43LFBdSHPBZhknwWD2MuCy6I0nEMyxNz2YeC43cBptiXlPcjxsSyV6giK75fv6FS/zl9jEqbH0a5SamnmDcKZBGlsrI/gu9rlWB7mG0XmGL39ghUmqJG53J2Vo2J2yGko+ay0F9uZzJ8WZKmxYqtsgjxGkQeQfZXzuJSOyZNxt8poGaWQcb9vB3QucOkTdPRneQRwzSHEsfyUYc2YrSCndk3MXTuO2/dk0HJjB05m+J+lSjJzCvbjmEKeM9oDWD9YSdcoJ+xRuvznppkw+LC1MoqWrw7Y5rjGKMo6V90WEiGoqoEaHg7PMrdBqFIhEajYa1C5O5ywbM1yTE5zXAP1avCk3OB+aS14gjtFfICi/MWjtA3z90yXpf8p/zJyOOiCiWwwAAAAedEVYdGljYzpjb3B5cmlnaHQAR29vZ2xlIEluYy4gMjAxNqwLMzgAAAAUdEVYdGljYzpkZXNjcmlwdGlvbgBzUkdCupBzBwAAAABJRU5ErkJggg==";
const SC_HERO = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAC+AgMAAAANTajRAAABAGlDQ1BpY2MAABiVY2BgPMEABCwGDAy5eSVFQe5OChGRUQrsDxgYgRAMEpOLCxhwA6Cqb9cgai/r4lGHC3CmpBYnA+kPQKxSBLQcaKQIkC2SDmFrgNhJELYNiF1eUlACZAeA2EUhQc5AdgqQrZGOxE5CYicXFIHU9wDZNrk5pckIdzPwpOaFBgNpDiCWYShmCGJwZ3AC+R+iJH8RA4PFVwYG5gkIsaSZDAzbWxkYJG4hxFQWMDDwtzAwbDuPEEOESUFiUSJYiAWImdLSGBg+LWdg4I1kYBC+wMDAFQ0LCBxuUwC7zZ0hHwjTGXIYUoEingx5DMkMekCWEYMBgyGDGQCm1j8/yRb+6wAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEXJqEzJqEz////KyOVbAAAAAXRSTlMAQObYZgAAAAFiS0dEAmYLfGQAAAAHdElNRQfqAxgKNx7OmY9lAAAHuUlEQVRo3rVYyY7kKhAkpcp7j+T8Hyy171iC//+VlwubcbUNh2f1dFfZhCGCJLdx7vuFKQW3diW+1hAokLVpSCBxcV3nsbYySGdKR/JLVHiOc4kMxrTKn9lv2xp/niAlXOKfkk8J1iAkBhMXIPx+9MBr8wuQjZyL2xIkCoRWIDGyvkS0NItC/u9ZZONpTTHZxbQIWd8XYplTXDkwKV/zCEiHWfLKwk5VLM5DUGgIoTAN2RLvPFtA2qYhdBzyYc5z/iSfdCaK6YjHNETXxSubVxl+o/lk+jcrGVAUK0sep1XGM4gZR4dHmIR8eNch6a9ZlenwFsVgWuWTnC3MTass2lI+mJOC/cYSK2dVBgoWK1mySZVZY0he9sbPqswaYxDFMMyqzBonMxiOF3MqnyTOhd0Fu5lJlVPE3SB7mFOZNdaAJP+2OR8LEr4MknBOZTzPUyxf7P84plT+8MDikxn8M6MxLydFg4QwpfLJgTLtYpN7ituUyuK/EjIEeXdoRmXW+BSLEQj75hlbBuHsZDsgurTPZFjIw3isQBh57hN+WTQOThkk2aMJlVlj8qDSyt8ZlU+GuAJxDHlXmfeCHCoB/s1fXlWGI2zRkUH4w4avkrEdC0SHwRyER2xZMJWM4FVlhoQG8YjwqjKzDVljVRndq8rsuIPHAgkMoTeVk0Ly8lEhLyoL2eCLj4DIkDfJBBJ9GQQJ6BUizzmtrstkyJvKKGd+rxCSjy8Q4Zqgykoy4YvKJNEI62v5+L+GMo121CDxNfoJVU6qqkQgueKzZBy4JLB2s/K08AhBc8U9RO6ER0iO3k1B/vYIYaZphKRnlS1F6l4qQcbTE4RTsGvaLm+I+KAySKF3XbnGsgfJgM1r5MqY/QGCArktNj35ZeQ1lDPcrJlX+zeEasWGKq7ipZaLD5CyLslH9rxDHMv+hnC9Huskta9AXMn/LVjRi3oIPlRYUBsJqYdIi8Ffx1U5MGWd4AJhG+vHeNdtN6aBSv5KlyGsZNsCFqyOuUKqZHIUnOTE+R10DuzrpEeGiLPmJNU71zbjyj5D2kHlPxDk52NeCJ4g+gDDj04RxVv5/mUwQMr0UjsKESdeVw8R9m9NWvVUG1WSWs7KLfSoJyteNfbuCiE9awEEC5x0pryW0CCu8zV5nzznBKikYtCT2kwpL6lBsvGB5Kg2bbDGwzPEGhM5iqIuu1Of7KXYPFrh5sCWDqcnS3LjX5DyHI5s0gkOS6VvkNAg8vysIZEQTOPQQ/p2H5rKPpRpmRM/bQ2ROwS0+k3VgIWT2e4TxAotX45a/MG+Ufd1YXLvQwXB89nz+BckV+bYnBP6YJV3G3CFWGWOECrEdoZ19FnBFC8Q0GKm7YrujFcLy2/huorXKB6vmLZGULarhtAzI+aSRwQpE+RI5DNP2WR6P4uH+Ap9Jt9+aSd16nklYrOMPkMHgWimb2Tw+IRDyoocvsRDqDodFW0FHilkQ4Vz3/6J68/hC7X815ZhT+ZMVMlA+MGPVJXBFqblf6zOrJIxg6E8J+wYw1aOrbmpCxUNVbrlNoan8/7zA6hfM5Vbs1B6zpLihLwS9nGM04VlKre4ZKacyfCgj4PN/egs9EerXJtohYw53I09r69U8BxnsWOXyUCuq/SbUWErHiCS6mFHJhhOIEYlwBgw+R1bZ2aYsvv3hYrfUks5DSLFfbczejwMYlQ2HLMbCWAdmbIU6StlKjjuviQqPRlXzyxqgsp4HBpMaqf9mWkvK2cFhyRKBNt9R6ZekvQmcnuAq8qgbtw6lc1XOTMw7WKqG++f6KQRj6OR6amcZ9D1hQtEc304b2R06OEt9+8h+o1FijcymYpsI14MUyHimkcyRsWc8RVizDhojmSMSkDKGvUQncufIxmjckBso5rG8srdR7qSiZqNwh7aWjrBtHrRKrqRUSo+5gqmlwzzZ668/YWMUoFSZmMHKXAC0I5Yq/i0W1ZCZC9ZTaj5uGJPRqgEDlghU26QIgXPcSGTqcTyvZOsfpSnHZlMhWgc103I6UxPJlOpx605zJYqox6lSsaoNAUx3T9J0Gxkyq7UEIldhlL3jtOZRsaotMSlZ9CEINw1TYuFSsCWuHRFeacdD9dOFxUq/Knb8zqy2yFp8Mh5ys5YTp3rQmRZz6UGjh8VVcgIFRb9pzPsUi5eIGIdYGRIU4g+camSXSpNFM9gZIwK9YcUah3hupvif5RMpoJ94lJoXxsNvBYjk6nA9Wns/xQyzoZFo+IHt2YvGOrow3YG865co71l40OfQZtCQsao+G5XqlRjNyOSkTEq8RoIbPDYAKBYOAuVsdbVJY2dGWk9lh5saUcOko3vUROxTq+az7iGm2BChuOPeFSJhDCmFErjBuEwo86OHSEHli+Qe/tHB2rrVsHDsvX/i9ztrtJWGe5Vu/alxptW0kYSw6TbQ8nT700G+oDeR799eRjdkMwomfiRktbRz9eHX1br1EzAq+ncHyZ3p2KuyIqDbw9d+HJXmcvB/NZMQfftQi9bKAHKzV5w6u77y7F/uRJbgDqO+Utckbqn+UuOMH3bsgcyefcXIFJp9lXkFJnw7xdXqGiliQu7omSkvl+i4uwgr10Efo2K1Jb/1qiI37s645krru2Kklml4m7OeIbMn1T+AxuMtAy4m6eeAAAAHnRFWHRpY2M6Y29weXJpZ2h0AEdvb2dsZSBJbmMuIDIwMTasCzM4AAAAFHRFWHRpY2M6ZGVzY3JpcHRpb24Ac1JHQrqQcwcAAAAASUVORK5CYII=";
const SC_FOOTER = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA9AgMAAABgu4dSAAABAGlDQ1BpY2MAABiVY2BgPMEABCwGDAy5eSVFQe5OChGRUQrsDxgYgRAMEpOLCxhwA6Cqb9cgai/r4lGHC3CmpBYnA+kPQKxSBLQcaKQIkC2SDmFrgNhJELYNiF1eUlACZAeA2EUhQc5AdgqQrZGOxE5CYicXFIHU9wDZNrk5pckIdzPwpOaFBgNpDiCWYShmCGJwZ3AC+R+iJH8RA4PFVwYG5gkIsaSZDAzbWxkYJG4hxFQWMDDwtzAwbDuPEEOESUFiUSJYiAWImdLSGBg+LWdg4I1kYBC+wMDAFQ0LCBxuUwC7zZ0hHwjTGXIYUoEingx5DMkMekCWEYMBgyGDGQCm1j8/yRb+6wAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEXJqEzJqEz////KyOVbAAAAAXRSTlMAQObYZgAAAAFiS0dEAmYLfGQAAAAHdElNRQfqAxgKNx+5nr/zAAABVklEQVQ4y4WSQY4EIQhFccEN4D66cI8J3P8qw8ealHYv2qRt66kPRIl2U6e7RdzfLaJfgCPsBq6/wNeWn0Aj7sxC/c7M1fVK1ONONTO/AQPYBVwvoG58VeQLxOptxhlk9raOMG1NojVfwEOIZNgBUqgHUJSL/Q1TSfFRgDpHO64mF+g0jjcNTBvtRLJn3zVNdc4tB9AH6CSJwACAs25StekUXuuB2/QX6ErvQvyw6iMPCQlWRMUWnCzLtUGNCBJBFCEpBXYyxkL2nEZj9ETSxnPeTMzS58zPhQck6HTFvuiVkmwWUyFlk5TkxAhhhOXOKcl/dmsA2iuTyqIhjEKbEoMSIH+yRm9jSs0CsJhxdgXgaVOy4SDcqSH0mmy4cHwxQEpKgfX1PHN/KWCUfVUi+5qE9onXLAXC7EchqxS5mfY7YtkKau/bPl92Se7vLOkHYPsA7V/xBzCPYfBiGAoDAAAAHnRFWHRpY2M6Y29weXJpZ2h0AEdvb2dsZSBJbmMuIDIwMTasCzM4AAAAFHRFWHRpY2M6ZGVzY3JpcHRpb24Ac1JHQrqQcwcAAAAASUVORK5CYII=";

const PAGES = ["home", "history", "about", "join", "contact"];

// ─── Color & Style Tokens ───
const palette = {
  navy: "#0b1a2e",
  navyLight: "#132744",
  navyMid: "#0f2038",
  gold: "#c9a84c",
  goldLight: "#dfc278",
  goldDark: "#a08434",
  cream: "#f4efe4",
  creamDark: "#e8e0d0",
  charcoal: "#1a1a1a",
  warmWhite: "#faf8f4",
  textLight: "#d4cfc4",
  textMuted: "#8a8478",
};

// ─── SVG Icons ───
function SquareCompassIcon({ size = 48, color = palette.gold }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
      <path d="M50 8 L20 88 L35 88 L50 42 L65 88 L80 88 Z" stroke={color} strokeWidth="2.5" fill="none" />
      <path d="M25 30 L75 30" stroke={color} strokeWidth="2" />
      <path d="M30 30 L50 75 L70 30" stroke={color} strokeWidth="2.5" fill="none" />
      <circle cx="50" cy="28" r="3" fill={color} />
    </svg>
  );
}

function ChevronDown({ color = palette.gold }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

function MenuIcon({ color = palette.cream }) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
      <path d="M3 12h18M3 6h18M3 18h18" />
    </svg>
  );
}

function CloseIcon({ color = palette.cream }) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}

// ─── Components ───

function Header({ currentPage, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const el = document.getElementById("scroll-container");
    if (!el) return;
    const handler = () => setScrolled(el.scrollTop > 60);
    el.addEventListener("scroll", handler);
    return () => el.removeEventListener("scroll", handler);
  }, []);

  const navItems = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "history", label: "History" },
    { id: "charity", label: "Charity" },
    { id: "join", label: "Join Us" },
    { id: "links", label: "Links" },
    { id: "contact", label: "Contact" },
  ];

  return (
    <>
      <header
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          background: scrolled ? "rgba(11,26,46,0.97)" : "transparent",
          backdropFilter: scrolled ? "blur(12px)" : "none",
          borderBottom: scrolled ? `1px solid rgba(201,168,76,0.15)` : "1px solid transparent",
          transition: "all 0.4s ease",
          padding: scrolled ? "12px 0" : "20px 0",
        }}
      >
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div
            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 14 }}
            onClick={() => { setPage("home"); setMobileOpen(false); }}
          >
            <img src={SC_NAV} alt="Square & Compass" style={{ width: scrolled ? 32 : 40, height: scrolled ? 32 : 40, objectFit: "contain", transition: "all 0.3s" }} />
            <div>
              <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: scrolled ? 16 : 18, color: palette.cream, fontWeight: 600, letterSpacing: "0.02em", lineHeight: 1.2, transition: "font-size 0.3s" }}>
                Past & Present Lodge
              </div>
              <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 11, color: palette.gold, letterSpacing: "0.15em", textTransform: "uppercase" }}>
                No. 2665
              </div>
            </div>
          </div>

          {/* Desktop nav */}
          <nav style={{ display: "flex", gap: 8, alignItems: "center" }} className="desktop-nav">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => setPage(item.id)}
                style={{
                  background: "none",
                  border: "none",
                  color: currentPage === item.id ? palette.gold : palette.textLight,
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 13,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  cursor: "pointer",
                  padding: "8px 16px",
                  borderRadius: 4,
                  transition: "all 0.3s",
                  fontWeight: currentPage === item.id ? 600 : 400,
                  position: "relative",
                }}
              >
                {item.label}
                {currentPage === item.id && (
                  <span style={{ position: "absolute", bottom: 2, left: "50%", transform: "translateX(-50%)", width: 20, height: 2, background: palette.gold, borderRadius: 1 }} />
                )}
              </button>
            ))}
          </nav>

          {/* Mobile hamburger */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileOpen(!mobileOpen)}
            style={{ background: "none", border: "none", cursor: "pointer", padding: 4, display: "none" }}
          >
            {mobileOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </header>

      {/* Mobile menu overlay */}
      {mobileOpen && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 999,
          background: "rgba(11,26,46,0.98)", backdropFilter: "blur(20px)",
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8,
        }}>
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => { setPage(item.id); setMobileOpen(false); }}
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: currentPage === item.id ? palette.gold : palette.cream,
                fontFamily: "'Playfair Display', Georgia, serif",
                fontSize: 28, padding: "12px 32px", letterSpacing: "0.04em",
                transition: "color 0.3s",
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}

      <style>{`
        
        .mobile-menu-btn { display: none !important; }
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </>
  );
}

function Footer({ setPage }) {
  const footerLinks = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "history", label: "History" },
    { id: "charity", label: "Charity" },
    { id: "join", label: "Join Us" },
    { id: "links", label: "Links" },
    { id: "contact", label: "Contact" },
  ];
  return (
    <footer style={{
      background: palette.navy,
      borderTop: `1px solid rgba(201,168,76,0.2)`,
      padding: "60px 24px 40px",
    }}>
      <div style={{ maxWidth: 1000, margin: "0 auto", textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
          <img src={SC_FOOTER} alt="Square & Compass" style={{ width: 48, height: 48, objectFit: "contain", opacity: 0.8 }} />
        </div>
        <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 18, color: palette.cream, marginTop: 16, marginBottom: 4 }}>
          Past & Present Lodge No. 2665
        </div>
        <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 13, color: palette.textMuted, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 28 }}>
          Of Antient, Free, and Accepted Masons of England
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 24, flexWrap: "wrap", marginBottom: 32 }}>
          {footerLinks.map((p) => (
            <button key={p.id} onClick={() => setPage(p.id)} style={{
              background: "none", border: "none", color: palette.textMuted, cursor: "pointer",
              fontFamily: "'DM Sans', sans-serif", fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase",
              transition: "color 0.3s",
            }}
              onMouseEnter={(e) => e.target.style.color = palette.gold}
              onMouseLeave={(e) => e.target.style.color = palette.textMuted}
            >
              {p.label}
            </button>
          ))}
        </div>
        {/* Social media icons */}
        <div style={{ display: "flex", justifyContent: "center", gap: 20, marginBottom: 28 }}>
          <a href="https://www.facebook.com/SussexMasons/" target="_blank" rel="noopener noreferrer" style={{ color: palette.textMuted, transition: "color 0.3s" }} onMouseEnter={(e) => e.currentTarget.style.color = palette.gold} onMouseLeave={(e) => e.currentTarget.style.color = palette.textMuted}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
          </a>
          <a href="https://www.instagram.com/sussex_masons/" target="_blank" rel="noopener noreferrer" style={{ color: palette.textMuted, transition: "color 0.3s" }} onMouseEnter={(e) => e.currentTarget.style.color = palette.gold} onMouseLeave={(e) => e.currentTarget.style.color = palette.textMuted}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C16.67.014 16.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
          </a>
          <a href="https://x.com/SussexMasons" target="_blank" rel="noopener noreferrer" style={{ color: palette.textMuted, transition: "color 0.3s" }} onMouseEnter={(e) => e.currentTarget.style.color = palette.gold} onMouseLeave={(e) => e.currentTarget.style.color = palette.textMuted}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
          </a>
        </div>
        <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 10, color: "rgba(138,132,120,0.6)", marginBottom: 20 }}>
          Follow Sussex Freemasons on social media
        </div>
        <div style={{ width: 60, height: 1, background: `rgba(201,168,76,0.3)`, margin: "0 auto 24px" }} />
        <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: palette.textMuted, lineHeight: 1.8 }}>
          Meeting at the Sussex Masonic Centre, Queen's Road, Brighton
          <br />
          Under the Province of Sussex · United Grand Lodge of England
          <br />
          © {new Date().getFullYear()} Past & Present Lodge No. 2665
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 16, marginTop: 16, flexWrap: "wrap" }}>
          {[
            { id: "privacy", label: "Privacy Policy" },
            { id: "terms", label: "Terms of Use" },
            { id: "cookies", label: "Cookie Policy" },
          ].map((p, i) => (
            <span key={p.id}>
              <button onClick={() => setPage(p.id)} style={{
                background: "none", border: "none", cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif", fontSize: 10,
                color: "rgba(138,132,120,0.5)", transition: "color 0.3s",
                padding: 0, textDecoration: "underline",
              }}
                onMouseEnter={(e) => e.target.style.color = palette.textMuted}
                onMouseLeave={(e) => e.target.style.color = "rgba(138,132,120,0.5)"}
              >
                {p.label}
              </button>
              {i < 2 && <span style={{ color: "rgba(138,132,120,0.3)", margin: "0 4px" }}>·</span>}
            </span>
          ))}
        </div>
      </div>
    </footer>
  );
}

function SectionHeading({ eyebrow, title, subtitle, light = false }) {
  return (
    <div style={{ textAlign: "center", marginBottom: 48 }}>
      {eyebrow && (
        <div style={{
          fontFamily: "'DM Sans', sans-serif", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase",
          color: palette.gold, marginBottom: 12, fontWeight: 500,
        }}>
          {eyebrow}
        </div>
      )}
      <h2 style={{
        fontFamily: "'Playfair Display', Georgia, serif",
        fontSize: "clamp(28px, 4vw, 42px)",
        color: light ? palette.cream : palette.charcoal,
        fontWeight: 600,
        margin: 0,
        lineHeight: 1.2,
      }}>
        {title}
      </h2>
      {subtitle && (
        <p style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: 18, color: light ? palette.textLight : palette.textMuted,
          marginTop: 16, maxWidth: 600, marginLeft: "auto", marginRight: "auto",
          lineHeight: 1.6, fontStyle: "italic",
        }}>
          {subtitle}
        </p>
      )}
      <div style={{ width: 48, height: 2, background: palette.gold, margin: "24px auto 0", borderRadius: 1 }} />
    </div>
  );
}

function GoldButton({ children, onClick, variant = "filled" }) {
  const [hovered, setHovered] = useState(false);
  const filled = variant === "filled";
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: filled ? (hovered ? palette.goldLight : palette.gold) : "transparent",
        color: filled ? palette.navy : (hovered ? palette.gold : palette.cream),
        border: filled ? "none" : `1px solid ${hovered ? palette.gold : "rgba(201,168,76,0.5)"}`,
        fontFamily: "'DM Sans', sans-serif",
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: "0.1em",
        textTransform: "uppercase",
        padding: "14px 36px",
        borderRadius: 2,
        cursor: "pointer",
        transition: "all 0.3s ease",
        transform: hovered ? "translateY(-1px)" : "none",
      }}
    >
      {children}
    </button>
  );
}

// ─── Pages ───

function HomePage({ setPage }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  const pillars = [
    { title: "Brotherly Love", desc: "The foundation of Freemasonry, encouraging us to regard all mankind as one family and to treat every person with respect, kindness, and compassion." },
    { title: "Relief", desc: "Our commitment to supporting those in need, whether fellow Masons, their families, or the wider community, through charitable giving and practical support." },
    { title: "Truth", desc: "The call to live with integrity and honesty in all our dealings, encouraging continuous self-improvement and sincerity in our relationships." },
  ];

  return (
    <div>
      {/* Hero */}
      <section style={{
        minHeight: "100vh",
        background: `linear-gradient(175deg, ${palette.navy} 0%, ${palette.navyLight} 40%, ${palette.navy} 100%)`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "120px 24px 80px",
        position: "relative",
        overflow: "hidden",
      }}>
        {/* Decorative elements */}
        <div style={{
          position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
          background: "radial-gradient(ellipse at 30% 20%, rgba(201,168,76,0.04) 0%, transparent 60%), radial-gradient(ellipse at 70% 80%, rgba(201,168,76,0.03) 0%, transparent 50%)",
          pointerEvents: "none",
        }} />
        <div style={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          width: 500, height: 500,
          border: `1px solid rgba(201,168,76,0.06)`,
          borderRadius: "50%",
          pointerEvents: "none",
        }} />
        <div style={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          width: 700, height: 700,
          border: `1px solid rgba(201,168,76,0.03)`,
          borderRadius: "50%",
          pointerEvents: "none",
        }} />

        <div style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(30px)",
          transition: "all 1s ease",
          position: "relative",
          zIndex: 1,
        }}>
          <div style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 11,
            letterSpacing: "0.3em",
            textTransform: "uppercase",
            color: palette.gold,
            marginBottom: 20,
          }}>
            Est. 1897 · Brighton, Sussex
          </div>
          <h1 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: "clamp(36px, 6vw, 64px)",
            color: palette.cream,
            fontWeight: 600,
            lineHeight: 1.15,
            margin: 0,
            maxWidth: 700,
          }}>
            Past & Present
            <br />
            <span style={{ color: palette.gold }}>Lodge No. 2665</span>
          </h1>
          <p style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: "clamp(16px, 2.5vw, 22px)",
            color: palette.textLight,
            fontStyle: "italic",
            marginTop: 20,
            lineHeight: 1.5,
            maxWidth: 520,
            marginLeft: "auto",
            marginRight: "auto",
          }}>
            Of Antient, Free, and Accepted Masons of England
          </p>
          <div style={{ display: "flex", gap: 16, justifyContent: "center", marginTop: 40, flexWrap: "wrap" }}>
            <GoldButton onClick={() => setPage("about")}>Discover Our Lodge</GoldButton>
            <GoldButton onClick={() => setPage("join")} variant="outline">Become a Mason</GoldButton>
          </div>
        </div>

        <div style={{
          position: "absolute", bottom: 32, left: "50%", transform: "translateX(-50%)",
          opacity: visible ? 0.6 : 0, transition: "opacity 1.5s ease 0.8s",
          animation: "bobDown 2s ease-in-out infinite",
        }}>
          <ChevronDown />
        </div>
        <style>{`
          @keyframes bobDown {
            0%, 100% { transform: translateX(-50%) translateY(0); }
            50% { transform: translateX(-50%) translateY(8px); }
          }
        `}</style>
      </section>

      {/* Welcome */}
      <section style={{ background: palette.warmWhite, padding: "80px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <SectionHeading eyebrow="Welcome" title="Over 125 Years of Brotherhood" subtitle="One of Sussex's most distinctive Masonic lodges, founded in 1897 by former pupils of Brighton Grammar School." />
          <div style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17,
            lineHeight: 1.85,
            color: "#4a4540",
            textAlign: "center",
            maxWidth: 680,
            margin: "0 auto",
          }}>
            <p>
              Whether you're a Master Mason considering visiting us, a member looking for information about upcoming meetings, or simply curious about Freemasonry in Brighton, we're delighted you've found us. Past & Present combines the best of Masonic tradition with a warm, friendly atmosphere.
            </p>
            <p style={{ marginTop: 20 }}>
              We meet at the Sussex Masonic Centre, a building with its own deep connections to our lodge's history, and we're proud to continue the legacy of brotherhood and fellowship that our founders established more than a century ago.
            </p>
          </div>
        </div>
      </section>

      {/* Three Pillars */}
      <section style={{ background: palette.navy, padding: "80px 24px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          <SectionHeading eyebrow="Our Principles" title="The Three Grand Pillars" light />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 32 }}>
            {pillars.map((p, i) => (
              <div key={i} style={{
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(201,168,76,0.12)",
                borderRadius: 4,
                padding: "40px 28px",
                textAlign: "center",
                transition: "border-color 0.3s, background 0.3s",
              }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(201,168,76,0.3)"; e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(201,168,76,0.12)"; e.currentTarget.style.background = "rgba(255,255,255,0.03)"; }}
              >
                <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, letterSpacing: "0.2em", color: palette.gold, marginBottom: 12 }}>
                  {["I", "II", "III"][i]}
                </div>
                <h3 style={{
                  fontFamily: "'Playfair Display', Georgia, serif",
                  fontSize: 22,
                  color: palette.cream,
                  fontWeight: 600,
                  margin: "0 0 16px",
                }}>
                  {p.title}
                </h3>
                <p style={{
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  fontSize: 16,
                  color: palette.textLight,
                  lineHeight: 1.7,
                  margin: 0,
                }}>
                  {p.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who We Are teaser */}
      <section style={{ background: palette.creamDark, padding: "80px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto", textAlign: "center" }}>
          <SectionHeading eyebrow="Who We Are" title="A Brotherhood of Good Men" />
          <p style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17, lineHeight: 1.85, color: "#4a4540", maxWidth: 640, margin: "0 auto",
          }}>
            We're a diverse group of men from across Sussex and beyond who meet regularly to practice Freemasonry, enjoy each other's company, and support one another through life's journey. Our members include teachers, businessmen, tradesmen, retirees, and professionals from every background imaginable.
          </p>
          <div style={{ marginTop: 32 }}>
            <GoldButton onClick={() => setPage("about")}>Learn More About Us</GoldButton>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{
        background: `linear-gradient(170deg, ${palette.navyLight} 0%, ${palette.navy} 100%)`,
        padding: "80px 24px",
        textAlign: "center",
      }}>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <SectionHeading eyebrow="Begin Your Journey" title="Interested in Becoming a Mason?" light subtitle="There's no obligation and no pressure, just a friendly conversation about what we do and what membership involves." />
          <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
            <GoldButton onClick={() => setPage("join")}>Find Out More</GoldButton>
            <GoldButton onClick={() => setPage("contact")} variant="outline">Get in Touch</GoldButton>
          </div>
        </div>
      </section>
    </div>
  );
}

function HistoryPage({ setPage }) {
  const events = [
    { year: "1897", title: "Foundation", text: "A group of Old Boys from Brighton Grammar School petition for and are granted a warrant for a new lodge. On 6th May, the Past & Present Lodge is established, named after the school magazine. The lodge is consecrated on 4th October at Blanchard's Restaurant, Beak Street, London." },
    { year: "1900", title: "On the Move", text: "Blanchard's closes for refurbishment that never completes. The lodge moves to Great Queen Street, London, and begins a peripatetic existence, meeting at various London venues and occasionally gathering at the school in Brighton." },
    { year: "1911", title: "Hampshire Lodge Sponsored", text: "The lodge sponsors the Hampshire Lodge No. 3538, consecrated at the Waldorf Hotel, Aldwych, demonstrating the growing reach and influence of the Past & Present brethren." },
    { year: "1912", title: "The Foundation Stone", text: "Brighton Grammar School moves to Dyke Road. On 13th June, the foundation stone is laid with full Masonic rite. It was the last occasion Masons appeared in public in Brighton in full regalia. Five hundred attend the luncheon at the Dome." },
    { year: "1920", title: "Brighton Class of Instruction", text: "With membership growing among Brighton residents, a Class of Instruction is established in Brighton in addition to the London class, reflecting the lodge's dual identity." },
    { year: "1947", title: "Golden Jubilee", text: "The lodge celebrates fifty years with a special installation meeting at Freemasons' Hall, Great Queen Street, attended by a contingent from Grand Lodge." },
    { year: "1951", title: "Headmaster Initiated", text: "Brother H. Brogden, headmaster of the school, is initiated at a special meeting attended by 150 brethren including the Provincial Grand Master, continuing the tradition of headmasters joining the lodge." },
    { year: "1965", title: "The Move to Sussex", text: "After decades of dual London-Brighton meetings, the lodge formally relocates to the Sussex Masonic Temple, Queen's Road, Brighton. It becomes a Sussex lodge whilst retaining its own ritual tradition for installations." },
    { year: "1972", title: "75th Anniversary", text: "A special meeting at the Masonic Hall, Worthing, attended by over 200 brethren, features an entertaining demonstration of a 1790 lodge meeting, with brethren in period costume." },
    { year: "1989", title: "Temple Extension", text: "The Brighton Masonic Centre is extended under Provincial Grand Master Rt. W. Brother D.W. Llewellyn. Past & Present plays its part in fundraising and earns a commemorative plaque in the new temple." },
    { year: "1997", title: "Centenary", text: "Past & Present celebrates one hundred years of Freemasonry with a centenary meeting at the Sussex Masonic Centre, having evolved from a closed school lodge into a welcoming lodge open to all Master Masons." },
    { year: "Today", title: "The Lodge Continues", text: "Now over 125 years old, Past & Present Lodge continues the traditions established by its founders, blending rich heritage with a welcoming approach to Freemasonry in the 21st century." },
  ];

  return (
    <div>
      <section style={{
        background: `linear-gradient(175deg, ${palette.navy} 0%, ${palette.navyLight} 100%)`,
        padding: "140px 24px 80px",
        textAlign: "center",
      }}>
        <SectionHeading eyebrow="Since 1897" title="Our History" light subtitle="From a London restaurant in Soho to the Sussex Masonic Centre in Brighton, the story of a lodge that has endured for over a century." />
      </section>

      <section style={{ background: palette.warmWhite, padding: "80px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <p style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 18, lineHeight: 1.85, color: "#4a4540", textAlign: "center",
            marginBottom: 60, fontStyle: "italic",
          }}>
            In the latter part of the nineteenth century, a number of people associated with the Brighton Grammar School considered forming a Masonic lodge so that Old Boys and Staff who were Freemasons could maintain their association with the school. The school's motto, "Absque Labore Nihil" (meaning "Nothing Without Work"), was adopted by the lodge and incorporated into its banner.
          </p>

          {/* Timeline */}
          <div style={{ position: "relative" }}>
            {/* Vertical line */}
            <div style={{
              position: "absolute", left: 80, top: 0, bottom: 0, width: 1,
              background: `linear-gradient(to bottom, ${palette.gold}, rgba(201,168,76,0.1))`,
            }} className="timeline-line" />

            {events.map((ev, i) => (
              <div key={i} style={{
                display: "flex", gap: 32, marginBottom: 48, position: "relative",
                alignItems: "flex-start",
              }}>
                <div style={{
                  minWidth: 80, textAlign: "right",
                  fontFamily: "'Playfair Display', Georgia, serif",
                  fontSize: 18, fontWeight: 700, color: palette.gold,
                  paddingTop: 4,
                }}>
                  {ev.year}
                </div>
                <div style={{
                  width: 10, height: 10, borderRadius: "50%",
                  background: palette.gold, border: `3px solid ${palette.warmWhite}`,
                  position: "relative", zIndex: 1, marginTop: 8,
                  flexShrink: 0, boxShadow: `0 0 0 2px ${palette.gold}`,
                }} />
                <div style={{ flex: 1 }}>
                  <h3 style={{
                    fontFamily: "'Playfair Display', Georgia, serif",
                    fontSize: 20, color: palette.charcoal, fontWeight: 600,
                    margin: "0 0 8px",
                  }}>
                    {ev.title}
                  </h3>
                  <p style={{
                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                    fontSize: 16, color: "#5a5550", lineHeight: 1.75, margin: 0,
                  }}>
                    {ev.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <style>{`
            @media (max-width: 600px) {
              .timeline-line { left: 12px !important; }
            }
          `}</style>
        </div>
      </section>

      {/* School Lodges */}
      <section style={{ background: palette.creamDark, padding: "80px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <SectionHeading eyebrow="Tradition" title="School Lodges" subtitle="A unique and cherished tradition within English Freemasonry" />
          <div style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17, lineHeight: 1.85, color: "#4a4540", textAlign: "center",
          }}>
            <p>
              School lodges were founded by former pupils of particular schools, creating a Masonic connection to their alma mater. The tradition flourished in the late Victorian and Edwardian eras, when many of Britain's public schools and grammar schools established their own lodges.
            </p>
            <p style={{ marginTop: 16 }}>
              The concept was simple but powerful: men who had shared their formative years at school could continue that fellowship through Freemasonry. Some of Britain's most prestigious schools have associated lodges, including Eton, Harrow, and Winchester. Like Past & Present, many have adapted by opening their membership beyond the school community whilst retaining their heritage and unique character.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section style={{ background: palette.navy, padding: "80px 24px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <SectionHeading eyebrow="Gallery" title="Through the Years" light subtitle="A glimpse into the lodge's history and heritage" />

          {/* Featured image */}
          <div style={{ marginBottom: 32 }}>
            <div style={{
              borderRadius: 4,
              overflow: "hidden",
              border: "1px solid rgba(201,168,76,0.15)",
            }}>
              <img
                src="/centenary-1997.jpg.jpg"
                alt="Brethren of Past & Present Lodge at the Centenary Meeting and Banner Dedication, 1997"
                style={{ width: "100%", height: "auto", display: "block" }}
              />
            </div>
            <div style={{ textAlign: "center", marginTop: 12 }}>
              <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: palette.gold, marginBottom: 4 }}>
                Centenary Meeting
              </div>
              <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 14, color: palette.textLight, lineHeight: 1.5, fontStyle: "italic" }}>
                Brethren at the centenary meeting and banner dedication, Sussex Masonic Centre, 1997
              </div>
            </div>
          </div>

          {/* Placeholder cards for future images */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16 }}>
            {[
              { label: "Lodge Banner", desc: "The original Past & Present Lodge banner, consecrated 1897" },
              { label: "Foundation Stone", desc: "Laying of the Brighton Grammar School foundation stone, 13th June 1912" },
              { label: "Lodge Warrant", desc: "The original warrant granted by H.R.H. Albert Edward, Prince of Wales" },
              { label: "Hudson's Letter", desc: "W. Bro C.W. Hudson's petition letter to Grand Secretary, April 1897" },
              { label: "Officers 1897", desc: "The founding officers of Past & Present Lodge" },
            ].map((item, i) => (
              <div key={i} style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(201,168,76,0.1)",
                borderRadius: 4,
                padding: 24,
                textAlign: "center",
                minHeight: 160,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}>
                <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: palette.gold, marginBottom: 8 }}>
                  {item.label}
                </div>
                <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 14, color: palette.textLight, lineHeight: 1.5, fontStyle: "italic" }}>
                  {item.desc}
                </div>
              </div>
            ))}
          </div>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: palette.textMuted, textAlign: "center", marginTop: 24 }}>
            Further gallery images coming soon. We are in the process of digitising our historical archive.
          </p>
        </div>
      </section>
    </div>
  );
}

function AboutPage({ setPage }) {
  return (
    <div>
      <section style={{
        background: `linear-gradient(175deg, ${palette.navy} 0%, ${palette.navyLight} 100%)`,
        padding: "140px 24px 80px",
        textAlign: "center",
      }}>
        <SectionHeading eyebrow="Our Lodge" title="About Past & Present" light subtitle="A diverse group of men from across Sussex and beyond, united by shared values and commitment to making ourselves better." />
      </section>

      <section style={{ background: palette.warmWhite, padding: "80px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <div style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17, lineHeight: 1.85, color: "#4a4540",
          }}>
            <p>
              At our meetings, you'll find a relaxed and welcoming atmosphere where experienced Masons and newer members work side by side. We take our ritual seriously but ourselves less so. There's as much laughter over dinner as there is solemnity in the temple.
            </p>
            <p style={{ marginTop: 20 }}>
              Whether you're looking for a lodge that values tradition, appreciates good fellowship, or simply wants somewhere you can be yourself among brothers, Past & Present offers all of that. We're a lodge that looks forward while respecting where we've been, and we're always pleased to welcome visitors and new members who share our values.
            </p>
          </div>
        </div>
      </section>

      {/* Key facts */}
      <section style={{ background: palette.navy, padding: "64px 24px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 32, textAlign: "center" }}>
            {[
              { label: "Founded", value: "1897" },
              { label: "Lodge Number", value: "2665" },
              { label: "Province", value: "Sussex" },
              { label: "Meeting Place", value: "Brighton" },
            ].map((item, i) => (
              <div key={i}>
                <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 32, color: palette.gold, fontWeight: 700 }}>
                  {item.value}
                </div>
                <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: palette.textMuted, letterSpacing: "0.15em", textTransform: "uppercase", marginTop: 8 }}>
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Meeting Info */}
      <section style={{ background: palette.creamDark, padding: "80px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto", textAlign: "center" }}>
          <SectionHeading eyebrow="Where & When" title="Our Meetings" />
          <div style={{
            background: "white",
            border: `1px solid ${palette.creamDark}`,
            borderRadius: 4,
            padding: "40px 32px",
            boxShadow: "0 2px 20px rgba(0,0,0,0.04)",
          }}>
            <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 20, color: palette.charcoal, marginBottom: 8 }}>
              Sussex Masonic Centre
            </div>
            <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 16, color: palette.textMuted, marginBottom: 24, fontStyle: "italic" }}>
              Queen's Road, Brighton, Sussex
            </div>
            <div style={{ width: 40, height: 1, background: palette.gold, margin: "0 auto 24px" }} />
            <p style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: 16, color: "#5a5550", lineHeight: 1.8,
            }}>
              We meet four times a year at the Sussex Masonic Centre. Our regular meetings are held on the third Wednesday in February, the fourth Wednesday in April, the second Tuesday in October (Installation), and the third Tuesday in December. Visitors are warmly welcomed. If you'd like to attend one of our meetings, please get in touch via our contact page and our Secretary will be delighted to arrange your visit.
            </p>
            <div style={{ marginTop: 24 }}>
              <GoldButton onClick={() => setPage("contact")}>Contact Our Secretary</GoldButton>
            </div>
          </div>
        </div>
      </section>

      {/* Notable connections */}
      <section style={{ background: palette.warmWhite, padding: "80px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <SectionHeading eyebrow="Heritage" title="Notable Connections" subtitle="Past & Present has been woven into the fabric of Brighton's history" />
          <div style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17, lineHeight: 1.85, color: "#4a4540", textAlign: "center",
          }}>
            <p>
              The lodge's founder, Charles William Hudson, was a distinguished Freemason and accountant who ran his own household removal firm with offices across the south of England. He had followed his father into Masonry and held the rank of Provincial Grand Warden for Sussex.
            </p>
            <p style={{ marginTop: 20 }}>
              Brother Louis Ginnett, initiated in 1914, was a celebrated painter who exhibited at the Royal Academy, co-designed the iconic pylons welcoming visitors to Brighton on the A23, and painted the ceiling of the main temple at the Sussex Masonic Centre, a connection Past & Present is quietly proud of.
            </p>
            <p style={{ marginTop: 20 }}>
              The lodge also enjoyed the distinction of having Rt. Worshipful Brother Sir Leonard Barford M.A., the Provincial Grand Master of Sussex, apply to become a full member, a rare honour that reflects the esteem in which the lodge was held.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

function JoinPage({ setPage }) {
  return (
    <div>
      <section style={{
        background: `linear-gradient(175deg, ${palette.navy} 0%, ${palette.navyLight} 100%)`,
        padding: "140px 24px 80px",
        textAlign: "center",
      }}>
        <SectionHeading eyebrow="Your Journey Begins" title="Becoming a Freemason" light subtitle="Freemasonry isn't a secret society. It's a society with secrets, and those secrets are simply the ways we recognise one another and the lessons we teach through our ritual." />
      </section>

      <section style={{ background: palette.warmWhite, padding: "80px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <div style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17, lineHeight: 1.85, color: "#4a4540",
            textAlign: "center",
            maxWidth: 680,
            margin: "0 auto",
          }}>
            <p>
              What we do is straightforward: we use ancient ceremonies and symbolism to encourage men to become better versions of themselves, to support one another, and to contribute positively to society.
            </p>
            <p style={{ marginTop: 20 }}>
              Joining Past & Present Lodge means becoming part of something larger than yourself. You'll learn meaningful lessons through our ritual, make genuine friendships with men from all walks of life, and have the opportunity to develop yourself both personally and morally.
            </p>
          </div>
        </div>
      </section>

      {/* What we look for */}
      <section style={{ background: palette.creamDark, padding: "80px 24px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <SectionHeading eyebrow="What We Look For" title="Good Men Who Want to Improve" />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 28, maxWidth: 800, margin: "0 auto" }}>
            {[
              { title: "Integrity", desc: "We seek men of good character who conduct themselves with honesty and sincerity in all their dealings." },
              { title: "Friendship", desc: "A desire for genuine fellowship and the willingness to support your brothers through life's journey." },
              { title: "Curiosity", desc: "An open mind and a willingness to learn: about yourself, about others, and about the ancient traditions of the Craft." },
              { title: "Belief", desc: "A belief in a Supreme Being, however you may define that. Freemasonry is open to men of all faiths." },
            ].map((item, i) => (
              <div key={i} style={{
                background: "white",
                padding: "32px 24px",
                borderRadius: 4,
                borderLeft: `3px solid ${palette.gold}`,
                boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
              }}>
                <h3 style={{
                  fontFamily: "'Playfair Display', Georgia, serif",
                  fontSize: 18, color: palette.charcoal, fontWeight: 600, margin: "0 0 12px",
                }}>
                  {item.title}
                </h3>
                <p style={{
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  fontSize: 15, color: "#5a5550", lineHeight: 1.7, margin: 0,
                }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Already a Mason */}
      <section style={{ background: palette.navy, padding: "80px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto", textAlign: "center" }}>
          <SectionHeading eyebrow="Already a Mason?" title="Visitors Welcome" light subtitle="If you're a Master Mason and would like to visit Past & Present, we'd be delighted to have you." />
          <p style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17, color: palette.textLight, lineHeight: 1.8,
            marginBottom: 32,
          }}>
            We also warmly welcome joining members, whether you're a Mason looking for a new lodge, someone returning to Freemasonry after time away, or a brother who simply appreciates our heritage and fellowship.
          </p>
          <GoldButton onClick={() => setPage("contact")}>Get in Touch</GoldButton>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: palette.warmWhite, padding: "80px 24px", textAlign: "center" }}>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <SectionHeading eyebrow="Take the First Step" title="Ready to Learn More?" subtitle="There's no obligation and no pressure, just a friendly conversation." />
          <GoldButton onClick={() => setPage("contact")}>Contact Us Today</GoldButton>
        </div>
      </section>

      {/* FAQ */}
      <section style={{ background: palette.creamDark, padding: "80px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <SectionHeading eyebrow="Common Questions" title="Frequently Asked Questions" />
          <FAQSection />
        </div>
      </section>
    </div>
  );
}

function ContactPage() {
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", phone: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleSubmit = async () => {
    if (!form.firstName || !form.email || !form.message) {
      setError("Please fill in all required fields.");
      return;
    }
    setSending(true);
    setError("");
    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_key: "d68b97f2-69d9-4396-bf08-ea7576cb46f0",
          subject: "New enquiry from Past & Present Lodge website",
          from_name: "Past & Present Lodge Website",
          name: `${form.firstName} ${form.lastName}`.trim(),
          email: form.email,
          phone: form.phone || "Not provided",
          message: form.message,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setSubmitted(true);
      } else {
        setError("Something went wrong. Please try again or email us directly.");
      }
    } catch (err) {
      setError("Unable to send your message. Please check your connection and try again.");
    } finally {
      setSending(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "14px 16px",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 14,
    border: `1px solid ${palette.creamDark}`,
    borderRadius: 3,
    background: "white",
    color: palette.charcoal,
    outline: "none",
    transition: "border-color 0.3s",
    boxSizing: "border-box",
  };

  const labelStyle = {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 11,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: palette.textMuted,
    marginBottom: 6,
    display: "block",
  };

  return (
    <div>
      <section style={{
        background: `linear-gradient(175deg, ${palette.navy} 0%, ${palette.navyLight} 100%)`,
        padding: "140px 24px 80px",
        textAlign: "center",
      }}>
        <SectionHeading eyebrow="Get in Touch" title="Contact Us" light subtitle="Whether you have a question about the lodge, wish to visit, or are interested in becoming a Mason, we'd love to hear from you." />
      </section>

      <section style={{ background: palette.warmWhite, padding: "80px 24px" }}>
        <div style={{ maxWidth: 560, margin: "0 auto" }}>
          {submitted ? (
            <div style={{ textAlign: "center", padding: "40px 0" }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
              <h3 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 24, color: palette.charcoal, marginBottom: 12 }}>
                Thank You
              </h3>
              <p style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 17, color: "#5a5550", lineHeight: 1.7 }}>
                Your message has been sent. Our Secretary will be in touch shortly.
              </p>
            </div>
          ) : (
            <div>
              <p style={{
                fontFamily: "'Cormorant Garamond', Georgia, serif",
                fontSize: 17, color: "#5a5550", textAlign: "center", lineHeight: 1.7, marginBottom: 40,
              }}>
                Please fill in the form below to contact our Lodge Secretary. All enquiries are treated in complete confidence.
              </p>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                <div>
                  <label style={labelStyle}>First Name *</label>
                  <input style={inputStyle} value={form.firstName} onChange={handleChange("firstName")}
                    onFocus={(e) => e.target.style.borderColor = palette.gold}
                    onBlur={(e) => e.target.style.borderColor = palette.creamDark} />
                </div>
                <div>
                  <label style={labelStyle}>Last Name</label>
                  <input style={inputStyle} value={form.lastName} onChange={handleChange("lastName")}
                    onFocus={(e) => e.target.style.borderColor = palette.gold}
                    onBlur={(e) => e.target.style.borderColor = palette.creamDark} />
                </div>
              </div>
              <div style={{ marginTop: 20 }}>
                <label style={labelStyle}>Email *</label>
                <input style={inputStyle} type="email" value={form.email} onChange={handleChange("email")}
                  onFocus={(e) => e.target.style.borderColor = palette.gold}
                  onBlur={(e) => e.target.style.borderColor = palette.creamDark} />
              </div>
              <div style={{ marginTop: 20 }}>
                <label style={labelStyle}>Phone</label>
                <input style={inputStyle} type="tel" value={form.phone} onChange={handleChange("phone")}
                  onFocus={(e) => e.target.style.borderColor = palette.gold}
                  onBlur={(e) => e.target.style.borderColor = palette.creamDark} />
              </div>
              <div style={{ marginTop: 20 }}>
                <label style={labelStyle}>Message *</label>
                <textarea style={{ ...inputStyle, minHeight: 140, resize: "vertical" }} value={form.message} onChange={handleChange("message")}
                  onFocus={(e) => e.target.style.borderColor = palette.gold}
                  onBlur={(e) => e.target.style.borderColor = palette.creamDark} />
              </div>
              {error && (
                <p style={{
                  color: "#c0392b",
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 13,
                  marginTop: 16,
                  textAlign: "center",
                }}>
                  {error}
                </p>
              )}
              <div style={{ marginTop: 28, textAlign: "center" }}>
                <GoldButton onClick={handleSubmit}>
                  {sending ? "Sending..." : "Send Message"}
                </GoldButton>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Location */}
      <section style={{ background: palette.creamDark, padding: "64px 24px" }}>
        <div style={{ maxWidth: 600, margin: "0 auto", textAlign: "center" }}>
          <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", color: palette.gold, marginBottom: 12 }}>
            Where to Find Us
          </div>
          <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 22, color: palette.charcoal, marginBottom: 8 }}>
            Sussex Masonic Centre
          </div>
          <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 17, color: "#5a5550", lineHeight: 1.7 }}>
            Queen's Road, Brighton, East Sussex
            <br />
            Under the Province of Sussex
            <br />
            United Grand Lodge of England
          </div>
        </div>
      </section>
    </div>
  );
}

// ─── FAQ Component ───

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);
  const faqs = [
    { q: "What is Freemasonry?", a: "Freemasonry is one of the world's oldest and largest fraternal organisations. It uses ancient ceremonies and symbolism to encourage its members to practise charity, to live with integrity, and to treat every person with kindness and respect. It is not a religion, a political movement, or a secret society." },
    { q: "What happens at a Masonic meeting?", a: "A typical meeting consists of two parts: a formal ceremony in the temple room, followed by a meal together (known as the \"festive board\"). The ceremonies are structured around symbolic lessons about self-improvement, and the dinner is a relaxed and sociable occasion. Meetings usually last around three to four hours in total." },
    { q: "What do I need to believe to join?", a: "Freemasonry requires a belief in a Supreme Being, but it is not a religion and does not require adherence to any particular faith. Members of all religions are welcome. Freemasonry does not seek to replace your faith, nor does it provide a substitute for it." },
    { q: "How much does it cost?", a: "There is an initiation fee and an annual subscription. These vary from lodge to lodge but are broadly comparable to membership of any social or sporting club. The subscription covers the cost of meals at meetings, charitable contributions, and the running costs of the lodge. Your proposer will be happy to discuss specific figures with you." },
    { q: "Do I need to know another Freemason to join?", a: "Traditionally, candidates are proposed by an existing member, but this is not always necessary. If you don't know any Freemasons, simply get in touch with us through our contact page and we'll arrange for you to meet some of our members informally." },
    { q: "Is Freemasonry a secret society?", a: "No. Freemasonry is a society with traditions. Some of our ceremonies are private, just as many clubs and organisations have private proceedings. Members are free to acknowledge their membership and talk about Freemasonry openly. Our meeting place, officers, and meeting dates are all publicly available." },
    { q: "What's the time commitment?", a: "Past & Present meets four times a year. Many members also attend a lodge of instruction (a practice meeting) and social events. Beyond that, the commitment is what you make of it. Some members are very active, others attend just the regular meetings. There's no pressure either way." },
    { q: "Can women join?", a: "Past & Present Lodge is part of the United Grand Lodge of England, which admits men only. However, there are two well-established women's Grand Lodges in England, the Order of Women Freemasons and Freemasonry for Women, both of which are recognised and respected by UGLE." },
  ];

  return (
    <div>
      {faqs.map((faq, i) => (
        <div key={i} style={{
          borderBottom: "1px solid rgba(201,168,76,0.15)",
          marginBottom: 0,
        }}>
          <button
            onClick={() => setOpenIndex(openIndex === i ? null : i)}
            style={{
              width: "100%", textAlign: "left", background: "none", border: "none",
              padding: "20px 0", cursor: "pointer", display: "flex",
              justifyContent: "space-between", alignItems: "center", gap: 16,
            }}
          >
            <span style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontSize: 17, color: openIndex === i ? palette.gold : palette.charcoal,
              fontWeight: 600, transition: "color 0.3s", lineHeight: 1.4,
            }}>
              {faq.q}
            </span>
            <span style={{
              fontFamily: "'DM Sans', sans-serif", fontSize: 18,
              color: palette.gold, flexShrink: 0,
              transform: openIndex === i ? "rotate(45deg)" : "none",
              transition: "transform 0.3s",
            }}>
              +
            </span>
          </button>
          {openIndex === i && (
            <div style={{
              padding: "0 0 20px",
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: 16, color: "#5a5550", lineHeight: 1.75,
            }}>
              {faq.a}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

// ─── Charity Page ───

function CharityPage({ setPage }) {
  return (
    <div>
      <section style={{
        background: `linear-gradient(175deg, ${palette.navy} 0%, ${palette.navyLight} 100%)`,
        padding: "140px 24px 80px", textAlign: "center",
      }}>
        <SectionHeading eyebrow="Giving Back" title="Charity & Service" light subtitle="Charitable giving has been at the heart of Past & Present Lodge since its foundation in 1897." />
      </section>

      <section style={{ background: palette.warmWhite, padding: "80px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <div style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17, lineHeight: 1.85, color: "#4a4540", textAlign: "center",
            maxWidth: 680, margin: "0 auto",
          }}>
            <p>
              Freemasonry is one of the largest charitable givers in the country, and Past & Present Lodge is proud to play its part. From our earliest days, the lodge has supported causes both within and beyond the Masonic family, from funding hospital beds in Kashmir to supporting the building of Brighton Grammar School.
            </p>
            <p style={{ marginTop: 20 }}>
              Today, our charitable efforts continue through both the lodge and the wider Provincial and national Masonic charitable structures.
            </p>
          </div>
        </div>
      </section>

      {/* Charitable distinctions */}
      <section style={{ background: palette.navy, padding: "64px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 32, textAlign: "center" }}>
            {[
              { title: "Double Patron", desc: "Royal Masonic Hospital" },
              { title: "Patron", desc: "Royal Masonic Hospital Redevelopment & Modernisation Fund" },
              { title: "£32,000", desc: "Donated to the Masonic Boys School in 1912, more than the cost of the school building itself" },
            ].map((item, i) => (
              <div key={i} style={{
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(201,168,76,0.12)",
                borderRadius: 4, padding: "32px 24px",
              }}>
                <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 22, color: palette.gold, fontWeight: 700, marginBottom: 8 }}>
                  {item.title}
                </div>
                <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 15, color: palette.textLight, lineHeight: 1.6 }}>
                  {item.desc}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ background: palette.creamDark, padding: "80px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <SectionHeading eyebrow="Our History of Giving" title="A Legacy of Support" />
          <div style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17, lineHeight: 1.85, color: "#4a4540", textAlign: "center",
          }}>
            <p>
              The lodge has a long tradition of significant charitable giving. In its early years, funds were raised for the Brighton Grammar School building fund, with the lodge presenting £32,000 to the Governing Body of the Masonic Boys School in 1912, a remarkable sum at the time.
            </p>
            <p style={{ marginTop: 16 }}>
              Lodge members supported hospital cots in Kashmir through the Kashmir Fund, where Dr. A. Neve and Dr. E. Neve, brothers and Old Boys of the school, ran a medical mission. Donations were also made for the relief of distressed brethren in Japan in 1922.
            </p>
            <p style={{ marginTop: 16 }}>
              The lodge holds the distinction of being a Double Patron of the Royal Masonic Hospital and a Patron of the Royal Masonic Hospital Redevelopment and Modernisation Fund, reflecting over a century of sustained and generous charitable giving.
            </p>
          </div>
        </div>
      </section>

      <section style={{ background: palette.warmWhite, padding: "80px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <SectionHeading eyebrow="Freemasonry Today" title="How Freemasons Give" subtitle="Masonic charity operates at every level, from the local lodge to the national stage" />
          <div style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 17, lineHeight: 1.85, color: "#4a4540", textAlign: "center",
          }}>
            <p>
              At the national level, the Masonic Charitable Foundation is one of the largest grant-making charities in the country. In Sussex, the Province coordinates charitable efforts through its own structures, supporting local causes from food banks to hospices, scout groups to dementia care.
            </p>
            <p style={{ marginTop: 16 }}>
              At lodge level, each member contributes to the Fund of Benevolence, and the lodge makes regular charitable donations decided by the brethren. It's a system that ensures help reaches those who need it, Masons and non-Masons alike.
            </p>
          </div>
          <div style={{ marginTop: 32, textAlign: "center" }}>
            <GoldButton onClick={() => setPage("contact")}>Get in Touch</GoldButton>
          </div>
        </div>
      </section>
    </div>
  );
}

// ─── Links Page ───

function LinksPage() {
  const linkGroups = [
    {
      title: "Freemasonry in Sussex",
      links: [
        { name: "Provincial Grand Lodge of Sussex", url: "https://sussexmasons.org.uk/", desc: "The official website of Sussex Freemasons, our Province" },
        { name: "Sussex Masonic Centre", url: "https://sussexmasons.org.uk/", desc: "Our meeting place at 25 Queen's Road, Brighton" },
      ],
    },
    {
      title: "National Freemasonry",
      links: [
        { name: "United Grand Lodge of England", url: "https://www.ugle.org.uk/", desc: "The governing body of Freemasonry in England and Wales" },
        { name: "Masonic Charitable Foundation", url: "https://mcf.org.uk/", desc: "The Freemasons' national charity" },
      ],
    },

    {
      title: "Women's Freemasonry",
      links: [
        { name: "Order of Women Freemasons", url: "https://www.owf.org.uk/", desc: "One of two women's Grand Lodges recognised by UGLE" },
        { name: "Freemasonry for Women", url: "https://www.hfaf.org/", desc: "The other recognised women's Grand Lodge" },
      ],
    },
  ];

  return (
    <div>
      <section style={{
        background: `linear-gradient(175deg, ${palette.navy} 0%, ${palette.navyLight} 100%)`,
        padding: "140px 24px 80px", textAlign: "center",
      }}>
        <SectionHeading eyebrow="Resources" title="Useful Links" light subtitle="Helpful links to Freemasonry in Sussex, nationally, and beyond." />
      </section>

      <section style={{ background: palette.warmWhite, padding: "80px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          {linkGroups.map((group, gi) => (
            <div key={gi} style={{ marginBottom: 48 }}>
              <h3 style={{
                fontFamily: "'Playfair Display', Georgia, serif",
                fontSize: 22, color: palette.charcoal, fontWeight: 600,
                marginBottom: 20, paddingBottom: 12,
                borderBottom: `1px solid rgba(201,168,76,0.2)`,
              }}>
                {group.title}
              </h3>
              {group.links.map((link, li) => (
                <a
                  key={li}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "block",
                    padding: "16px 20px",
                    marginBottom: 8,
                    background: "white",
                    borderRadius: 4,
                    borderLeft: `3px solid ${palette.gold}`,
                    boxShadow: "0 1px 8px rgba(0,0,0,0.04)",
                    textDecoration: "none",
                    transition: "transform 0.2s, box-shadow 0.2s",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateX(4px)"; e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.08)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 1px 8px rgba(0,0,0,0.04)"; }}
                >
                  <div style={{
                    fontFamily: "'Playfair Display', Georgia, serif",
                    fontSize: 16, color: palette.charcoal, fontWeight: 600, marginBottom: 4,
                  }}>
                    {link.name} <span style={{ fontSize: 12, color: palette.gold }}>→</span>
                  </div>
                  <div style={{
                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                    fontSize: 14, color: palette.textMuted, lineHeight: 1.5,
                  }}>
                    {link.desc}
                  </div>
                </a>
              ))}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

// ─── Legal Pages ───

function LegalPage({ type }) {
  const content = {
    privacy: {
      title: "Privacy Policy",
      eyebrow: "Legal",
      sections: [
        { heading: "Introduction", text: "Past & Present Lodge No. 2665 (\"we\", \"our\", \"us\") is committed to protecting and respecting your privacy. This policy explains how we collect, use, and protect any personal information you provide to us through this website." },
        { heading: "Information We Collect", text: "When you use our contact form, we collect your name, email address, phone number (if provided), and the content of your message. We do not collect any information automatically through cookies or tracking technologies beyond what is strictly necessary for the website to function." },
        { heading: "How We Use Your Information", text: "We use the information you provide solely for the purpose of responding to your enquiry. If you enquire about membership, your details may be passed to the Lodge Secretary to facilitate your application. We will never sell, trade, or share your personal information with third parties for marketing purposes." },
        { heading: "Data Retention", text: "We retain your personal information only for as long as necessary to respond to your enquiry or process your membership application. Contact form submissions are typically deleted within 12 months unless there is an ongoing reason to retain them." },
        { heading: "Your Rights", text: "Under UK data protection law (UK GDPR), you have the right to access, correct, or delete any personal data we hold about you. You also have the right to object to or restrict the processing of your data. To exercise any of these rights, please contact us using the details on our Contact page." },
        { heading: "Data Controller", text: "The data controller for information collected through this website is the Secretary of Past & Present Lodge No. 2665, meeting at the Sussex Masonic Centre, Queen's Road, Brighton, East Sussex." },
        { heading: "Changes to This Policy", text: "We may update this privacy policy from time to time. Any changes will be posted on this page. This policy was last updated in 2025." },
      ],
    },
    terms: {
      title: "Terms of Use",
      eyebrow: "Legal",
      sections: [
        { heading: "Website Use", text: "This website is provided by Past & Present Lodge No. 2665 for informational purposes. By accessing and using this website, you accept and agree to be bound by these terms. If you do not agree with any part of these terms, please do not use the website." },
        { heading: "Content", text: "The content of this website is provided for general information only. While we make every effort to ensure accuracy, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or suitability of the information contained on the site." },
        { heading: "Intellectual Property", text: "All content on this website, including text, design, and layout, is the property of Past & Present Lodge No. 2665 unless otherwise stated. You may not reproduce, distribute, or use any content from this website without our prior written permission." },
        { heading: "External Links", text: "This website contains links to external websites. We have no control over the content or availability of those sites and accept no responsibility for them. The inclusion of a link does not imply endorsement of the linked website." },
        { heading: "Contact Form", text: "When you submit information through our contact form, you agree that the information you provide is accurate and that you consent to being contacted by a representative of the lodge in response to your enquiry." },
        { heading: "Limitation of Liability", text: "Past & Present Lodge No. 2665 shall not be liable for any loss or damage arising from the use of this website, including but not limited to indirect or consequential loss or damage." },
        { heading: "Governing Law", text: "These terms are governed by and construed in accordance with the laws of England and Wales. Any disputes arising from the use of this website shall be subject to the exclusive jurisdiction of the courts of England and Wales." },
      ],
    },
    cookies: {
      title: "Cookie Policy",
      eyebrow: "Legal",
      sections: [
        { heading: "What Are Cookies", text: "Cookies are small text files that are stored on your device when you visit a website. They are widely used to make websites work more efficiently and to provide information to website owners." },
        { heading: "How We Use Cookies", text: "This website uses only essential cookies that are strictly necessary for the website to function. We do not use any analytics, advertising, or tracking cookies. We do not use cookies to collect personal information about you." },
        { heading: "Essential Cookies", text: "Essential cookies are required for the basic functionality of the website. These may include cookies that remember your preferences during a single browsing session. These cookies do not collect any personally identifiable information and are deleted when you close your browser." },
        { heading: "Third-Party Cookies", text: "We do not allow any third parties to set cookies through this website. If you follow links to external websites from our site, those websites may set their own cookies according to their own policies." },
        { heading: "Managing Cookies", text: "You can control and manage cookies through your browser settings. Please note that removing or blocking cookies may affect the functionality of this website. For more information about cookies and how to manage them, visit allaboutcookies.org." },
        { heading: "Changes to This Policy", text: "We may update this cookie policy from time to time. Any changes will be posted on this page. This policy was last updated in 2025." },
      ],
    },
  };

  const page = content[type] || content.privacy;

  return (
    <div>
      <section style={{
        background: `linear-gradient(175deg, ${palette.navy} 0%, ${palette.navyLight} 100%)`,
        padding: "140px 24px 60px", textAlign: "center",
      }}>
        <SectionHeading eyebrow={page.eyebrow} title={page.title} light />
      </section>

      <section style={{ background: palette.warmWhite, padding: "60px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          {page.sections.map((s, i) => (
            <div key={i} style={{ marginBottom: 32 }}>
              <h3 style={{
                fontFamily: "'Playfair Display', Georgia, serif",
                fontSize: 18, color: palette.charcoal, fontWeight: 600,
                marginBottom: 10,
              }}>
                {s.heading}
              </h3>
              <p style={{
                fontFamily: "'Cormorant Garamond', Georgia, serif",
                fontSize: 16, color: "#5a5550", lineHeight: 1.75, margin: 0,
              }}>
                {s.text}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

// ─── App ───

export default function App() {
  const [currentPage, setCurrentPage] = useState("home");
  const scrollRef = useRef(null);

  const navigate = (page) => {
    setCurrentPage(page);
    const el = document.getElementById("scroll-container");
    if (el) el.scrollTop = 0;
  };

  const renderPage = () => {
    switch (currentPage) {
      case "history": return <HistoryPage setPage={navigate} />;
      case "about": return <AboutPage setPage={navigate} />;
      case "join": return <JoinPage setPage={navigate} />;
      case "charity": return <CharityPage setPage={navigate} />;
      case "links": return <LinksPage />;
      case "privacy": return <LegalPage type="privacy" />;
      case "terms": return <LegalPage type="terms" />;
      case "cookies": return <LegalPage type="cookies" />;
      case "contact": return <ContactPage />;
      default: return <HomePage setPage={navigate} />;
    }
  };

  return (
    <div
      id="scroll-container"
      ref={scrollRef}
      style={{
        width: "100%",
        height: "100vh",
        overflow: "auto",
        background: palette.navy,
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <Header currentPage={currentPage} setPage={navigate} />
      <main style={{ minHeight: "100vh" }}>
        {renderPage()}
      </main>
      <Footer setPage={navigate} />
    </div>
  );
}
